import { render, staticRenderFns } from "./CommonHead.vue?vue&type=template&id=2d2f7d2c&scoped=true&"
import script from "./CommonHead.vue?vue&type=script&lang=js&"
export * from "./CommonHead.vue?vue&type=script&lang=js&"
import style0 from "./CommonHead.vue?vue&type=style&index=0&id=2d2f7d2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2f7d2c",
  null
  
)

export default component.exports